@use "../../scss/variables.scss" as *;

:host {
    display: block;
    box-sizing: border-box;
    font-family: CircularStd, sans-serif;
}

.countdown-container {
    display: flex;    
    align-items: center;
    background-color: $wf-red;
    padding: 10px 24px;
    margin: 10px 0;
    gap: 8px;
    flex-flow: column wrap;
    justify-content: space-between;
    
    &.jc-center {
        justify-content: center !important;
    }
}

@media screen and (min-width: 960px) {
    .countdown-container {
        flex-flow: row nowrap;
    }
}

// Countdown
.countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
}

.countdown-item {
    color: $wf-white;
    font-weight: bold;

    .countdown-number-divider::before {
        content: ':';
    }
}

.countdown-item:first-child {
    margin-right: 8px;
}

// Headlines
.headlines {
    display: flex;
    align-items: center;
    color: $wf-white;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    text-align: center;

    @media screen and (min-width: 960px) {
        &.mr-48 {
            margin-right: 48px;
        }
    }
}

.headline {
    font-weight: bold;
}

@media screen and (min-width: 960px) {
    .headline {
        width: unset;
    }
}

.cta-button {    
    text-decoration: underline;

    a.cta-button-link {
        color: $wf-white;

        &:hover {
            color: $wf-black;     
        }
    }
}

// Voucher
.voucher-field {
    display: flex;
    align-items: center;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
    justify-content: center;
}

.voucher-code {
    display: flex;
    flex-direction: row;
}

.voucher-label {
    color: $wf-white;
}

.code {
    color: $wf-white;
    font-weight: bold;
}

.copy-button {
    background-color: inherit;
    color: $wf-white;
    display: flex;
    justify-content: end;
    align-items: center;
    width: 50px;
}

@media screen and (min-width: 960px) {
    .voucher-label {
        margin-right: 8px;
    }

    .copy-button {
        margin-right: 32px;
        justify-content: center;
    }
}

// Close Button
.close-button {
    position: absolute;
    right: 8px;
    top: 0;

    button {
        background-color: inherit;
        color: $wf-white;
        border: none;
        padding: 5px 10px;
        border-radius: 5px;
        cursor: pointer;
        font-weight: 900;
        font-size: 1rem;
    }
}

@media screen and (min-width: 960px) {
    .close-button {
        top: auto;
        right: 24px;
    }
}